import type { DataTableHeader } from '@/types/vuetify';
import i18n from '@/plugins/i18n';

export function createTransferPageHeaders(): DataTableHeader[] {
    const t = i18n.global.t;

    return [
        { title: t('transfer.columns.date'), value: 'created_at', key: 'created_at', align: 'start', sortable: true, nowrap: true },
        { title: t('transfer.columns.operation'), value: 'operation_id', key: 'operation_id', align: 'start', sortable: true, nowrap: true },
        { title: t('transfer.columns.status'), value: 'status_id', key: 'status_id', align: 'start', sortable: true, nowrap: true },
        { title: t('transfer.columns.user'), value: 'tool_user_name', key: 'tool_user_name', align: 'start', sortable: true, nowrap: true },
        { title: t('transfer.columns.agent'), value: 'agent_name', key: 'agent_name', align: 'start', sortable: true, nowrap: true },
        { title: t('transfer.columns.currency'), value: 'currency_id', key: 'currency_id', align: 'center', sortable: true, nowrap: true },
        { title: t('transfer.columns.amount'), value: 'amount', key: 'amount', align: 'end', sortable: true, nowrap: true },
        { title: t('transfer.columns.method'), value: 'method_id', key: 'method_id', align: 'start', sortable: true, nowrap: true },
        {
            title: t('transfer.columns.approvedBy'),
            value: 'approved_tool_user_name',
            key: 'approved_tool_user_name',
            align: 'start',
            sortable: true,
            nowrap: true,
        },
        { title: '', value: 'actions', key: 'actions', align: 'end', sortable: false, nowrap: true, width: 72, cellProps: { class: 'pl-0 pr-1' } },
    ];
}
